import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { mediaQuery } from '@lacedltd/laced-components'

export const Container = styled.div({
  width: '100%',
  paddingBottom: tokens.spacing[12],

  [mediaQuery.m.min]: {
    paddingBottom: tokens.spacing[13]
  }
})

export const CopyContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',

  svg: {
    marginBottom: tokens.spacing[3]
  }
})
